module.exports = {
          srcSet: __webpack_public_path__ + "e5c0fc0b12aaa6bf1e1d3c29b6ddeabb-374.png"+" 374w",
          images:[ {path: __webpack_public_path__ + "e5c0fc0b12aaa6bf1e1d3c29b6ddeabb-374.png",width: 374,height: 240}],
          src: __webpack_public_path__ + "e5c0fc0b12aaa6bf1e1d3c29b6ddeabb-374.png",
          toString:function(){return __webpack_public_path__ + "e5c0fc0b12aaa6bf1e1d3c29b6ddeabb-374.png"},
          
          width: 374,
          height: 240
        }